import React, { useState, useEffect, useRef, useCallback } from "react";
import Webcam from "react-webcam";
import { motion } from "framer-motion";
import "./index.css"; // para estilos
import axios from "axios";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";

export default function RankingGame() {
  const [players, setPlayers] = useState([]);

  const [ranking, setRanking] = useState(Array(10).fill(null));
  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [matchInfo, setMatchInfo] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    winner: null,
    scored: '',
    mvp:''
  })
const inputs = useRef([]);
const webcamRef = useRef(null);
const appRef = useRef(null);
const { pathname } = useLocation();
const journalId = pathname?.split('/')?.[3]
const capture = useCallback(async () => {
  if (!appRef.current) return;

  try {
    // Captura de pantalla con html2canvas
    const canvas = await html2canvas(appRef.current, {
      useCORS: true,          // permite imágenes remotas (CDN)
      logging: false,
      scale: 2,               // mejora resolución
    });

    const image = canvas.toDataURL("image/png");

    // 🟢 Convierte a Blob para descarga real (más compatible en móvil)
    const blob = await (await fetch(image)).blob();
    const url = URL.createObjectURL(blob);

    // 📸 DESCARGA AUTOMÁTICA (carpeta de descargas del teléfono)
    const link = document.createElement("a");
    link.href = url;
    link.download = `talacha_${Date.now()}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 🧹 Limpia el objeto URL temporal
    URL.revokeObjectURL(url);

    // 📱 Si el dispositivo permite compartir (móvil moderno)
    if (navigator.canShare && navigator.canShare({ files: [] })) {
      const file = new File([blob], `talacha_${Date.now()}.png`, { type: blob.type });
      await navigator.share({
        title: "Mi captura del Ranking ⚽",
        text: "Aquí está mi foto de la jornada",
        files: [file],
      });
    }
  } catch (err) {
    console.error("Error al capturar la pantalla:", err);
  }
}, []);



  const [valuesScore, setValuesScore] = useState(Array(2).fill(null))
  console.log('matchInfo', matchInfo)
      useEffect(()=>{
        const url = 'https://web-production-58ed.up.railway.app/api/getAllBasePlayer'
        axios.get(url).then(res=>{
            console.log('res', res)
            setPlayers(res?.data?.players.slice(0,10))
        }).catch(error => console.log(error))

    },[])

    useEffect(()=>{
        const url = 'https://web-production-58ed.up.railway.app/api/get/jornadabyid'
        axios.get(url, {params: {_id: journalId}}).then(res => {
            setMatchInfo(res.data?.jornada)
        }).catch(e => console.log(e))

    },[])
    useEffect(()=>{
window.scrollTo ( 0, 200);

    },[])

  useEffect(() => {
    nextPlayer();
  }, []);


  function nextPlayer() {
    const remaining = players.filter(
      (p) => !ranking.find((r) => r?.name === p.name)
    );
    if (remaining.length === 0) {
      setCurrentPlayer(null);
      return;
    }
    const random = remaining[Math.floor(Math.random() * remaining.length)];
    setCurrentPlayer(random);
  }

  function assignPosition(pos) {
    const updated = [...ranking];
    updated[pos - 1] = currentPlayer;
    setRanking(updated);
    nextPlayer();
  }

  const renderListWinnerInfo = (key)=>{
    console.log('matchInfo[key]', matchInfo?.[key])
    if(key === 'winner') return (
        <>
    <span>Ganador </span>
    <img style={{marginLeft:'3px'}} src={selectedOptions?.[key]?.pictureTeam} />
    </>

    )
    if(key === 'scored') return(
        <>
        <span>Marcador:   {selectedOptions?.[key]}</span>
        </>

    )

    if(key === 'mvp')return(
        <>
        <span>MVP:  </span>
        <p>{selectedOptions?.[key]?.name}</p>
        </>
    )
  }

   const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return; // only digits

    const newValues = [...valuesScore];
    newValues[index] = value;
    setValuesScore(newValues);

    if (value && index < 1) {
      inputs.current[index + 1].focus();
    }

  };

    const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !valuesScore[index] && index > 0) {
      inputs.current[index - 1].focus();
    }
  };


  return (
    <div ref={appRef} className="ranking-game">
      {/* Cámara */}
      <Webcam
        audio={false}
        mirrored
        screenshotFormat="image/jpeg"
        className="webcam"
        width={1000}
        height={600}
        ref={webcamRef}
      />

      {/* Carta flotante del jugador */}
      { (
        <motion.div
          className="floating-card"
          initial={{ scale: 0, rotate: 180, opacity: 0 }}
          animate={{ scale: 1, rotate: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
                <div style={{
                    display:'flex',
                    justifyContent:'space-around'
                }}>
                    <motion.div
                    whileTap={{ scale: 0.8, rotate: [0, 300, -300, 0] }}
              animate={{
                scale:  [1, 1.3, 1],
                rotate: [0, 10, -10, 0],

              }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
                    >
                     <img onClick={()=> setSelectedOptions(prev => ({...prev, ['winner']: matchInfo?.['equipoLocal'] }))} src={matchInfo?.['equipoLocal']?.pictureTeam} />
                    </motion.div>
                    <img onClick={()=> setSelectedOptions(prev => ({...prev, ['winner']: matchInfo?.['equipoVisitante'] }))} src={matchInfo?.['equipoVisitante']?.pictureTeam} />

                </div>
                <motion.div
                animate={
                    {scale: [1, 1.05, 1],}    
                    }
                transition={{
                  duration: 1.5,
                  repeat:  Infinity,
                  repeatType: "mirror",
                }}
                >
                                   {
                    selectedOptions?.['winner'] && !selectedOptions['mvp'] && !selectedOptions['scored'] ? (<div>
                        <p style={{fontSize:'20px', fontWeight:'bold'}}>¿El marcador ?</p>

                    </div>)  : !selectedOptions?.['winner'] && !selectedOptions['mvp'] && !selectedOptions['scored'] ?  (             <div>
                    <p style={{fontSize:'20px', fontWeight:'bold'}}>¿Quien gana {matchInfo?.jornada} ?</p>
                </div>
                ) : <p></p>
                }

                </motion.div>
                {/* Se comenta los jugadores ya aue aun no se tienen las fotos */}
                {/* <motion.div 
                   
                style={{display:'flex', overflowX:'scroll', }}>
                    {
                        selectedOptions?.['winner'] && !selectedOptions['mvp'] && selectedOptions['scored'] && (
                            selectedOptions?.['winner']?.jugadores?.map((player, i)=>(
                                <div onClick={()=> setSelectedOptions(prev => ({...prev, ['mvp']: player?.jugador}))} >
                                    <img style={{marginLeft:'10px', width:'60px'}} src={player?.jugador?.img} />
                                    {player?.jugador?.name}
                                </div>
                            ))
                        )
                    }

                </motion.div> */}
 
   
                <div style={{
                    display:'flex',
                    justifyContent:'space-around'
                }}>
                    {
                       selectedOptions?.['winner'] && !selectedOptions['mvp'] && !selectedOptions['scored'] && (
                        valuesScore?.map((score, i)=>(
                         <input 
                        ref={(el) => (inputs.current[i] = el)}
                         value={score}
                         inputMode="numeric" 
                         style={{width:'100px', height:'100px',
                            textAlign: 'center',borderRadius:'10px',
                             fontSize:'30px'
                          }} 
                          type="number" 
                            onChange={(e) => handleChange(e.target.value, i)}
                            onKeyDown={(e) => handleKeyDown(e, i)}


                          />


                        ))
                       ) 
                    }
                </div>
         
        </motion.div>
      )}
   

      {/* Lista de posiciones */}
      <div className="ranking-list">
        {['winner','scored','mvp'].map((p, i) => (
          <motion.div   initial={{ scale: 0.8, opacity: 0 }}
  animate={{ scale:selectedOptions[p] ? [1.1, 1] : [1,1], opacity: selectedOptions[p] ?   1 : 0 }}
  transition={{ duration: 0.8 }} key={i} className="rank-item">
            {renderListWinnerInfo(p)}

          </motion.div>
        ))}
      </div>

 

      {
        valuesScore[0] !== null && valuesScore[1] !== null && !selectedOptions['scored'] && (
                  <button onClick={()=>{
                    setSelectedOptions(prev => ({...prev, ['scored']: valuesScore.join('-')}))
                  }} className="shuffle-btn">🔀 Confirmar</button>

        )

      }
      {
         selectedOptions?.['winner'] &&  selectedOptions['scored'] && (
            <button className="shuffle-btn-saved" onClick={capture} >
                📸 Guardar Foto
            </button>
         )
      }

      <div className="player-shirt-img">
        {
          selectedOptions?.['winner'] && selectedOptions['scored'] && (
<motion.img
  key={selectedOptions?.winner?.teamShirtImg}
  src={selectedOptions?.winner?.teamShirtImg}
  initial={{
    scale: 0,
    rotate: -180,
    opacity: 0,
  }}
  animate={{
    scale: [0, 1.15, 1],
    rotate: [-180, 8, -8, 0],
    opacity: 1,
  }}
  transition={{
    duration: 1.5,
    ease: "easeOut",
  }}
/>
          )

        }

      </div>
    </div>
  );
}